<ng-container *ngIf="{ ois: optInSettings$ | async } as obs">

<header>
  <nav class="navbar navbar-expand-md">
    <a class="navbar-brand ms-4" href="#">{{obs.ois?.orgName}}</a>
  </nav>
</header>

  <div class="container">

    <div class="policy">

      <h2 id="-org-name-privacy-policy">{{obs.ois?.orgName}} Privacy Policy</h2>
      <p><em>Powered by Parlance LLC – Effective May 23 2025</em></p>
      <p>{{obs.ois?.orgName}} (“we,” “our,” “us”) uses the Parlance SMS platform to communicate with supporters, students, alumni, staff, and friends. Parlance LLC (“Parlance”) supplies the technology and provides support for this policy. For questions, email <strong><a href="mailto:support@parlance.app">support@parlance.app</a></strong> or write to Parlance LLC, 830 Glenwood Ave SE, Suite 510-408, Atlanta, GA 30316.</p>
      <h3 id="1-information-we-collect">1. Information We Collect</h3>
      <table>
        <thead>
        <tr>
          <th>Category</th>
          <th>Examples</th>
          <th>Source</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td><strong>Contact</strong></td>
          <td>name, phone number, email, address</td>
          <td>you</td>
        </tr>
        <tr>
          <td><strong>SMS Opt-In Data</strong></td>
          <td>phone number, opt-in time, message preferences</td>
          <td>you</td>
        </tr>
        <tr>
          <td><strong>Account/Donation</strong></td>
          <td>pledge details, event RSVPs, giving history</td>
          <td>you</td>
        </tr>
        <tr>
          <td><strong>Usage</strong></td>
          <td>IP address, device/browser data</td>
          <td>automatic</td>
        </tr>
        </tbody>
      </table>
      <p>We do <strong>not</strong> knowingly collect data from anyone under 18.</p>
      <h3 id="2-how-we-use-information">2. How We Use Information</h3>
      <p>We process your information to:</p>
      <ol>
        <li>send texts and emails you request;</li>
        <li>manage events, pledges, admissions or advancement activities;</li>
        <li>respond to inquiries;</li>
        <li>improve our engagement programs;</li>
        <li>comply with law and protect our community.</li>
      </ol>
      <h3 id="3-how-we-share-information">3. How We Share Information</h3>
      <ul>
        <li><strong>Parlance &amp; service providers</strong> acting on our behalf under contract (e.g., cloud hosting, payment processors).</li>
        <li><strong>Legal or business transfers</strong> if required by law or during a re-organization.</li>
      </ul>
      <blockquote>
        <p><strong>No mobile information (opt-in data, consent, phone numbers) will be shared or sold to third parties or affiliates for marketing or promotional purposes.</strong> All such data is used solely to deliver the requested communications.</p>
      </blockquote>
      <h3 id="4-messaging-terms-conditions">4. Messaging Terms &amp; Conditions</h3>
      <p>When you opt in to receive SMS/MMS communications from <strong>{{obs.ois?.orgName}}</strong>, you agree to receive fund-raising appeals, event invitations, thank-you notes, pledge reminders, admissions information, donor updates, and other advancement-related messages. Frequency varies, and <strong>message &amp; data rates may apply</strong>.</p>
      <p><strong>Help:</strong> Reply <strong>HELP</strong> to any message or email <strong><a href="mailto:support@parlance.app">support@parlance.app</a></strong> for assistance. Wireless carriers are not liable for delayed or undelivered texts.</p>
      <h3 id="5-opting-out">5. Opting Out</h3>
      <p>To stop receiving messages, reply <strong>STOP</strong> to any {{obs.ois?.orgName}} text. You will receive one confirmation and then no further messages unless you opt in again.</p>
      <h3 id="6-security-retention">6. Security &amp; Retention</h3>
      <p>We apply reasonable administrative, technical, and physical safeguards via Parlance and other vendors. Data is retained only as long as needed for the purposes above or as required by law, after which it is deleted or anonymized.</p>
      <h3 id="7-security-retention">7. We Do Not Sell Your Information</h3>
      <p>We will never sell your personal information, including your mobile opt-in information, to third parties for marketing purposes. Your information is used only for the purposes outlined in this policy.</p>
      <h3 id="8-your-rights">8. Your Rights</h3>
      <p>Depending on your location, you may access, correct, delete, or export your personal information. To exercise any right, email <strong><a href="mailto:support@parlance.app">support@parlance.app</a></strong>; we will verify and respond as required by law.</p>
      <h3 id="9-changes">9. Changes</h3>
      <p>We may update this policy. The “Effective Date” will change when revisions are posted. Continued use of our services after changes constitutes acceptance of the revised policy.</p>

    </div>
  </div>

</ng-container>
